import { render, staticRenderFns } from "./maketing-information-agree.modal.vue?vue&type=template&id=c6fcaf1a&"
import script from "./maketing-information-agree.modal.vue?vue&type=script&lang=ts&"
export * from "./maketing-information-agree.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports